/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminResetPasswordResponse
 */
export interface AdminResetPasswordResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminResetPasswordResponse
     */
    password: string;
}

/**
 * Check if a given object implements the AdminResetPasswordResponse interface.
 */
export function instanceOfAdminResetPasswordResponse(value: object): value is AdminResetPasswordResponse {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function AdminResetPasswordResponseFromJSON(json: any): AdminResetPasswordResponse {
    return AdminResetPasswordResponseFromJSONTyped(json, false);
}

export function AdminResetPasswordResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminResetPasswordResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function AdminResetPasswordResponseToJSON(json: any): AdminResetPasswordResponse {
    return AdminResetPasswordResponseToJSONTyped(json, false);
}

export function AdminResetPasswordResponseToJSONTyped(value?: AdminResetPasswordResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
    };
}

